import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MembershipPlanCard = ({ plan, isSelected, onSelect, isPopular }) => {
  return (
    <div
      className={`
        relative bg-card rounded-xl p-6 md:p-8 border-2 transition-all duration-250
        cursor-pointer hover:shadow-lg
        ${isSelected ? 'border-primary shadow-md' : 'border-border'}
        ${isPopular ? 'ring-2 ring-accent ring-offset-2' : ''}
      `}
      onClick={() => onSelect(plan?.id)}
    >
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-accent text-accent-foreground rounded-full text-xs font-medium">
          Most Popular
        </div>
      )}
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            {plan?.name}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">{plan?.description}</p>
        </div>
        {isSelected && (
          <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0">
            <Icon name="Check" size={18} />
          </div>
        )}
      </div>
      <div className="mb-6">
        <div className="flex items-baseline gap-2">
          <span className="text-4xl md:text-5xl font-heading font-bold text-foreground">
            ${plan?.price}
          </span>
          <span className="text-lg text-muted-foreground">/{plan?.billingCycle}</span>
        </div>
        {plan?.originalPrice && (
          <div className="flex items-center gap-2 mt-2">
            <span className="text-sm text-muted-foreground line-through">
              ${plan?.originalPrice}
            </span>
            <span className="text-sm font-medium text-success">
              Save ${plan?.originalPrice - plan?.price}
            </span>
          </div>
        )}
      </div>
      <div className="space-y-3 mb-6">
        {plan?.features?.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <Icon
              name={feature?.included ? 'Check' : 'X'}
              size={18}
              color={feature?.included ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
              className="flex-shrink-0 mt-0.5"
            />
            <span
              className={`text-sm ${
                feature?.included ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
      {plan?.trialDays && (
        <div className="bg-success/10 rounded-lg p-3 mb-4">
          <div className="flex items-center gap-2">
            <Icon name="Gift" size={18} color="var(--color-success)" />
            <span className="text-sm font-medium text-success">
              {plan?.trialDays}-day free trial included
            </span>
          </div>
        </div>
      )}
      <Button
        variant={isSelected ? 'default' : 'outline'}
        fullWidth
        onClick={() => onSelect(plan?.id)}
      >
        {isSelected ? 'Selected' : 'Select Plan'}
      </Button>
    </div>
  );
};

export default MembershipPlanCard;